import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFixtures = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "vectors-anchor-square-1" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 3,
			cy: 3,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 3,
			cy: 21,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 21,
			cy: 3,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 21,
			cy: 21,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 2.25,
			x2: 15.75,
			y2: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 21.75,
			y1: 15.75,
			x2: 21.75,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 21.75,
			x2: 15.75,
			y2: 21.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 8.25,
			x2: 2.25,
			y2: 15.75
		})
	]
});
export default SvgFixtures;
